import { render, staticRenderFns } from "./HeaderTop.vue?vue&type=template&id=312791f8"
import script from "./HeaderTop.vue?vue&type=script&lang=js"
export * from "./HeaderTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312791f8')) {
      api.createRecord('312791f8', component.options)
    } else {
      api.reload('312791f8', component.options)
    }
    module.hot.accept("./HeaderTop.vue?vue&type=template&id=312791f8", function () {
      api.rerender('312791f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/Header/HeaderTop.vue"
export default component.exports